export const GET_ALL_PARAMETERS = 'GET_ALL_PARAMETERS';
export const GET_ALL_PARAMETERS_SUCCESS = 'GET_ALL_PARAMETERS_SUCCESS';
export const GET_ALL_PARAMETERS_ERROR = 'GET_ALL_PARAMETERS_ERROR';
